import OrderedSetMultiSelect from 'components/inputs/dropdowns/OrderedSetMultiSelect';
import Immutable from 'immutable';
import React, { ReactElement } from 'react';

interface Props {
  editable: boolean;
  values: Immutable.OrderedSet<string>;
  options: Immutable.OrderedSet<string>;
  onChange: (values: Immutable.OrderedSet<string>) => void;
}

const Assignees = (props: Props): ReactElement => {
  const { editable, values, options, onChange } = props;

  return (
    <div>
      {editable ? (
        <OrderedSetMultiSelect
          id="update-punch-overlay-assignee-select"
          values={values}
          options={options}
          onChange={onChange}
        />
      ) : (
        <div className="font-size-5 light">
          {[...values.values()].join(', ')}
        </div>
      )}
    </div>
  );
};

export default Assignees;
